/* PDP hover magnifier — Amazon-style. On hover over the main image, a zoomed
   detail panel pops out to the right (over the info column), following the cursor. */
(function () {
  var ZOOM = 2.3;          // magnification factor
  var MIN_WIDTH = 768;     // desktop only

  function hiRes(src) {
    if (!src) return src;
    src = src.replace(/_(\d+)x(\d+)?(?=\.(jpe?g|png|webp|gif))/i, '');
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '1600');
      return u.href;
    } catch (e) { return src; }
  }

  function initGallery(gallery) {
    if (gallery.__nvdZoom) return;
    gallery.__nvdZoom = true;
    var feat = gallery.querySelector('.featured-image');
    if (!feat) return;

    var panel = document.createElement('div');
    panel.className = 'nvd-zoom-panel';
    gallery.appendChild(panel);

    var lens = document.createElement('div');
    lens.className = 'nvd-zoom-lens';
    feat.appendChild(lens);

    function activeImg() {
      return feat.querySelector('.variant-image.visible img')
          || feat.querySelector('figure:not(.hidden) img')
          || feat.querySelector('img');
    }

    function hide() {
      panel.style.display = 'none';
      lens.style.display = 'none';
    }

    function move(e) {
      if (window.innerWidth < MIN_WIDTH) { hide(); return; }
      var img = activeImg();
      if (!img) { hide(); return; }
      var ir = img.getBoundingClientRect();
      var fr = feat.getBoundingClientRect();
      var x = e.clientX - ir.left;
      var y = e.clientY - ir.top;
      if (x < 0 || y < 0 || x > ir.width || y > ir.height) { hide(); return; }

      panel.style.display = 'block';
      lens.style.display = 'block';

      var pw = panel.offsetWidth, ph = panel.offsetHeight;
      var lw = pw / ZOOM, lh = ph / ZOOM;
      var lx = Math.max(0, Math.min(x - lw / 2, ir.width - lw));
      var ly = Math.max(0, Math.min(y - lh / 2, ir.height - lh));

      // lens is positioned relative to .featured-image; offset by image's position within it
      var offX = ir.left - fr.left, offY = ir.top - fr.top;
      lens.style.width = lw + 'px';
      lens.style.height = lh + 'px';
      lens.style.left = (offX + lx) + 'px';
      lens.style.top = (offY + ly) + 'px';

      panel.style.backgroundSize = (ir.width * ZOOM) + 'px ' + (ir.height * ZOOM) + 'px';
      panel.style.backgroundPosition = '-' + (lx * ZOOM) + 'px -' + (ly * ZOOM) + 'px';
    }

    function show(e) {
      if (window.innerWidth < MIN_WIDTH) return;
      var img = activeImg();
      if (!img) return;
      panel.style.backgroundImage = 'url("' + hiRes(img.currentSrc || img.src) + '")';
      move(e);
    }

    feat.addEventListener('mouseenter', show);
    feat.addEventListener('mousemove', move);
    feat.addEventListener('mouseleave', hide);

    // prev / next arrows on the main image (hover-revealed) — switch via the thumbnails
    var figs = feat.querySelectorAll('[data-product-gallery-figure]');
    if (figs.length > 1) {
      function makeArrow(dir, cls, glyph) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nvd-gallery-arrow ' + cls;
        btn.setAttribute('aria-label', dir > 0 ? 'Next image' : 'Previous image');
        btn.innerHTML = glyph;
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var visible = feat.querySelector('.variant-image.visible') || feat.querySelector('figure:not(.hidden)');
          var cur = visible ? parseInt(visible.getAttribute('data-product-gallery-figure'), 10) : 0;
          var total = figs.length;
          var idx = (cur + dir + total) % total;
          var thumb = gallery.querySelector('[data-product-gallery-thumbnail="' + idx + '"]');
          if (thumb) thumb.click();
        });
        feat.appendChild(btn);
      }
      makeArrow(-1, 'nvd-gallery-arrow-prev', '‹');
      makeArrow(1, 'nvd-gallery-arrow-next', '›');

      // ---- Mobile: native scroll-snap carousel + dot indicators.
      // CSS (≤767px) lays the figures out as a horizontal scroll-snap row —
      // the browser provides finger-tracking and momentum. JS here only keeps
      // the dots in sync and bridges the theme's class-based switching
      // (variant jumps) into scroll positions. Desktop is untouched.
      var mqMobile = window.matchMedia('(max-width: 767px)');
      function scrollMode() {
        return mqMobile.matches && feat.scrollWidth > feat.clientWidth + 10;
      }
      var order = [].map.call(figs, function (f) { return f.getAttribute('data-product-gallery-figure'); });
      var total = figs.length;

      function curIdx() {
        var vis = feat.querySelector('.variant-image.visible') || feat.querySelector('figure:not(.hidden)');
        return vis ? vis.getAttribute('data-product-gallery-figure') : '0';
      }
      function posIndex() {
        if (scrollMode()) {
          return Math.max(0, Math.min(total - 1, Math.round(feat.scrollLeft / feat.clientWidth)));
        }
        var p = order.indexOf(curIdx());
        return p < 0 ? 0 : p;
      }
      function goTo(i, instant) {
        if (scrollMode()) {
          feat.scrollTo({ left: i * feat.clientWidth, behavior: instant ? 'auto' : 'smooth' });
        }
      }

      // dot indicator: max 4 visible, track slides to keep the active dot in view
      var DOT = 8, GAP = 8, SPAN = DOT + GAP, WINDOW = 4;
      var visibleDots = Math.min(total, WINDOW);

      var dots = document.createElement('div');
      dots.className = 'nvd-gallery-dots';
      var viewport = document.createElement('div');
      viewport.className = 'nvd-gallery-dots-viewport';
      viewport.style.width = (visibleDots * SPAN - GAP) + 'px';
      var track = document.createElement('div');
      track.className = 'nvd-gallery-dots-track';
      order.forEach(function (gi, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'nvd-gallery-dot';
        d.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + total);
        d.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(i);
        });
        track.appendChild(d);
      });
      viewport.appendChild(track);
      dots.appendChild(viewport);
      // anchor the dots OUTSIDE the scroller so they don't ride along with slide 1
      var dotsHome = feat.parentElement || gallery;
      if (getComputedStyle(dotsHome).position === 'static') dotsHome.style.position = 'relative';
      dotsHome.appendChild(dots);

      var windowStart = 0;
      function syncDots() {
        var pos = posIndex();
        [].forEach.call(track.children, function (d, i) {
          d.classList.toggle('nvd-dot-active', i === pos);
        });
        if (pos < windowStart) windowStart = pos;
        if (pos > windowStart + WINDOW - 1) windowStart = pos - (WINDOW - 1);
        windowStart = Math.max(0, Math.min(windowStart, Math.max(0, total - WINDOW)));
        track.style.transform = 'translateX(' + (-windowStart * SPAN) + 'px)';
      }

      // native scroll → dots (rAF-throttled), and once the scroll SETTLES,
      // tell the theme the slide is selected (thumbnail click). That keeps the
      // theme's own state — including its lazy per-figure zoom init — in step
      // with the swipe. Its class flip is invisible on mobile (slides are
      // force-shown), and the change-driven bridge below sees class == scroll,
      // so nothing loops.
      var rafPending = false, settleTimer = null, lastSettled = -1;
      feat.addEventListener('scroll', function () {
        if (!rafPending) {
          rafPending = true;
          requestAnimationFrame(function () { rafPending = false; syncDots(); });
        }
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          if (!scrollMode()) return;
          var pos = posIndex();
          if (pos === lastSettled) return;
          lastSettled = pos;
          var thumb = gallery.querySelector('[data-product-gallery-thumbnail="' + order[pos] + '"]');
          if (thumb) thumb.click();
        }, 160);
      }, { passive: true });

      // theme class flips (variant jumps) → scroll the carousel to match.
      // Only when the class-based current FIGURE actually changes — anything
      // else mutating classes inside the gallery (the video player toggles
      // plyr--playing etc.) must NOT yank the carousel back.
      var lastClassIdx = curIdx();
      new MutationObserver(function () {
        var c = curIdx();
        if (c !== lastClassIdx) {
          lastClassIdx = c;
          if (scrollMode()) {
            var p = order.indexOf(c);
            if (p > -1 && p !== posIndex()) goTo(p);
          }
        }
        syncDots();
      }).observe(feat, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden'] });

      // align to whatever figure the theme considers current on load
      if (scrollMode()) {
        var p0 = order.indexOf(curIdx());
        if (p0 > 0) goTo(p0, true);
      }
      syncDots();
    }

    // Current-image indicator: highlight the thumbnail of whichever image is on
    // screen, and keep it scrolled into view. The theme's own thumbnail attributes
    // are unreliable (thumb 0 stays "selected" forever), so we drive this off the
    // actually-visible main figure instead, and re-sync whenever it changes
    // (arrows, thumb clicks, variant swaps).
    var scroller = gallery.querySelector('.glider-contain');
    var thumbWrap = gallery.querySelector('.thumbnails');
    if (thumbWrap) {
      var thumbs = thumbWrap.querySelectorAll('[data-product-gallery-thumbnail]');

      function syncActiveThumb() {
        var vis = feat.querySelector('.variant-image.visible')
               || feat.querySelector('.variant-image:not(.hidden)');
        if (!vis) return;
        var idx = vis.getAttribute('data-product-gallery-figure');
        var active = null;
        thumbs.forEach(function (t) {
          var on = t.getAttribute('data-product-gallery-thumbnail') === idx;
          t.classList.toggle('nvd-thumb-active', on);
          if (on) active = t;
        });
        if (active && scroller) {
          var item = active.closest('[class*="thumb-image-"]') || active;
          var sr = scroller.getBoundingClientRect();
          var ir = item.getBoundingClientRect();
          if (ir.left < sr.left + 2 || ir.right > sr.right - 2) {
            scroller.scrollBy({
              left: (ir.left + ir.width / 2) - (sr.left + sr.width / 2),
              behavior: 'smooth'
            });
          }
        }
      }

      var mo = new MutationObserver(syncActiveThumb);
      mo.observe(feat, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden'] });
      syncActiveThumb();
    }
  }

  // ---- Mobile lightbox (replaces the theme's auto-zoom on phones):
  // tap an image slide → fullscreen viewer, image fit-to-screen (longest side
  // fills, aspect kept), pinch to zoom 1–4×, one-finger pan while zoomed,
  // exit via ✕ / backdrop tap / tap the image at 1×. The theme's ProductZoom
  // never fires on mobile (the opening tap is intercepted in capture phase);
  // desktop hover-zoom and desktop click-zoom are untouched.
  function initLightbox() {
    if (document.body.__nvdLightbox) return;
    document.body.__nvdLightbox = true;

    var mq = window.matchMedia('(max-width: 767px)');

    var box = document.createElement('div');
    box.className = 'nvd-lightbox';
    box.innerHTML =
      '<img class="nvd-lightbox-img" alt="">' +
      '<button type="button" class="nvd-lightbox-close" aria-label="Close">&times;</button>' +
      '<div class="nvd-lightbox-hint">Pinch to zoom \u00b7 tap to close</div>';
    document.body.appendChild(box);
    var img = box.querySelector('.nvd-lightbox-img');
    var closeBtn = box.querySelector('.nvd-lightbox-close');
    var hint = box.querySelector('.nvd-lightbox-hint');

    var scale = 1, tx = 0, ty = 0;
    function apply() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }
    function clampPan() {
      var maxX = (scale - 1) * img.clientWidth / 2;
      var maxY = (scale - 1) * img.clientHeight / 2;
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }

    function open(srcImg) {
      img.src = srcImg.getAttribute('data-zoom') || srcImg.currentSrc || srcImg.src;
      reset();
      box.classList.add('nvd-open');
      document.body.style.overflow = 'hidden';
      try {
        if (!localStorage.getItem('nvdLightboxHint')) {
          localStorage.setItem('nvdLightboxHint', '1');
          hint.classList.add('nvd-show');
          setTimeout(function () { hint.classList.remove('nvd-show'); }, 2800);
        }
      } catch (e) {}
    }
    function close() {
      box.classList.remove('nvd-open');
      hint.classList.remove('nvd-show');
      document.body.style.overflow = '';
      reset();
    }

    // open: intercept image-slide taps on mobile before the theme's zoom
    document.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var fig = e.target.closest && e.target.closest('.nvd-gallery .featured-image [data-product-gallery-figure]');
      if (!fig) return;
      if (e.target.closest('.plyr')) return; // video controls stay native
      var srcImg = fig.querySelector('img');
      if (!srcImg) return;
      e.preventDefault();
      e.stopPropagation(); // the theme's ProductZoom never sees this tap
      open(srcImg);
    }, true);

    closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });

    // gestures
    var g = null; // active gesture
    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
    function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }

    box.addEventListener('touchstart', function (e) {
      var t = e.touches;
      if (t.length === 2) {
        g = { kind: 'pinch', d0: dist(t), s0: scale, t0x: tx, t0y: ty, m0: mid(t) };
      } else if (t.length === 1) {
        g = { kind: 'tap', x: t[0].clientX, y: t[0].clientY, moved: false, at: Date.now() };
      }
    }, { passive: false });

    box.addEventListener('touchmove', function (e) {
      e.preventDefault(); // never let the page scroll/zoom underneath
      var t = e.touches;
      if (g && g.kind === 'pinch' && t.length === 2) {
        var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
        var m = mid(t);
        scale = Math.max(1, Math.min(4, g.s0 * dist(t) / g.d0));
        var r = scale / g.s0;
        tx = (m.x - cx) - r * ((g.m0.x - cx) - g.t0x); // keep the pinch midpoint pinned
        ty = (m.y - cy) - r * ((g.m0.y - cy) - g.t0y);
        clampPan();
        apply();
      } else if (g && t.length === 1) {
        var x = t[0].clientX, y = t[0].clientY;
        if (Math.abs(x - g.x) > 8 || Math.abs(y - g.y) > 8) g.moved = true;
        if (scale > 1) {
          tx += x - g.x; ty += y - g.y;
          g.x = x; g.y = y;
          clampPan();
          apply();
        }
      }
    }, { passive: false });

    box.addEventListener('touchend', function (e) {
      if (g && g.kind === 'pinch') {
        if (scale < 1.02) reset();
        g = e.touches.length === 1 ? { kind: 'tap', x: e.touches[0].clientX, y: e.touches[0].clientY, moved: true, at: Date.now() } : null;
        return;
      }
      if (g && g.kind === 'tap' && !g.moved && Date.now() - g.at < 350) {
        // tap: backdrop always closes; the image closes only at 1×
        if (e.target === box || scale === 1) close();
      }
      g = null;
    });
  }

  function boot() {
    document.querySelectorAll('.nvd-gallery').forEach(initGallery);
    initLightbox();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
